import React from 'react';
import Icon from '@/components/ui/AppIcon';
import SEOHeading from '@/components/common/SEOHeading';

interface Credential {
  id: number;
  title: string;
  organization: string;
  year: string;
  icon: string;
}

interface CredentialsSectionProps {
  credentials: Credential[];
}

const CredentialsSection = ({ credentials }: CredentialsSectionProps) => {
  return (
    <section className="mb-16">
      <div className="mb-8 text-center">
        <SEOHeading level={2} className="mb-3">
          Professional Credentials & Certifications
        </SEOHeading>
        <p className="text-muted-foreground">
          Recognized excellence in Labrador breeding and care
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        {credentials.map((credential) => (
          <div
            key={credential.id}
            className="rounded-xl bg-card p-6 shadow-warm transition-smooth hover:shadow-warm-md"
          >
            <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-lg bg-primary/10">
              <Icon
                name={credential.icon as any}
                size={28}
                variant="solid"
                className="text-primary"
              />
            </div>
            <h3 className="mb-2 font-heading text-lg font-semibold text-foreground">
              {credential.title}
            </h3>
            <p className="mb-1 text-sm text-muted-foreground">
              {credential.organization}
            </p>
            <p className="text-xs font-medium text-secondary">
              Since {credential.year}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CredentialsSection;